module.exports = __webpack_public_path__ + "static/img/年度最佳相机.b8581568.png";